const getCookie = (name) => {
  const cookies = document.cookie.split('; ')
  const cookie = cookies.find((row) => row.startsWith(`${name}=`))
  return cookie ? decodeURIComponent(cookie.split('=')[1]) : null
}

const karteLogin = (user) => {
  const id = getCookie('krt.vis')
  if (typeof krt === 'function') {
    try {
      const {
        hubsynch_id,
        orange_id,
        customer_no,
        last_name,
        first_name,
        last_name_kana,
        first_name_kana,
        email,
        birthdate,
        gender,
        postal_code,
        prefecture_code,
        city,
        building,
        phone_number,
        store_id,
      } = user

      const userLoginData = {
        user_id: `vis-${id}`,
        hubsynch_id: String(hubsynch_id),
        orange_id: String(orange_id),
        customer_no,
        last_name,
        first_name,
        last_name_kana,
        first_name_kana,
        email,
        birthdate,
        gender,
        postal_code,
        prefecture_code,
        city,
        building,
        phone_number,
        store_id: String(store_id),
        attribute_hook: true,
      }

      if (typeof krt === 'function') {
        krt('send', 'identify', userLoginData)
      }
    } catch (error) {
      console.error('Error parsing user Data:', error)
    }
  }
}

const getStylistDisplayName = (free_status, gender_preference, stylistName) => {
  if (free_status) {
    if (gender_preference === 'm') {
      return '男性希望'
    } else if (gender_preference === 'f') {
      return '女性希望'
    } else {
      return 'フリー'
    }
  }
  return stylistName
}

const karteReservationCompleted = async (reservation) => {
  try {
    const {
      store: { id: storeId },
      stylists,
      start_date,
      id: reservationId,
      code,
      status,
      user: { email },
      free_status,
      gender_preference,
    } = reservation

    const services = reservation.services || []
    const mainService = services.find((service) => service.exclusive_group === 'main')?.name || null
    const subServices = services
      .filter((service) => service.is_sub_treatment)
      .map((service) => service.name)

    const stylistName = stylists?.[0]?.name || null
    const displayName = getStylistDisplayName(free_status, gender_preference, stylistName)

    const createdReservationData = {
      store_id: String(storeId),
      main_service: mainService,
      sub_service: subServices,
      stylist_name: displayName,
      rsv_start_date: start_date,
      wait_for_cancel: status === 'waiting',
      reservation_id: String(reservationId),
      reservation_code: code,
      email,
    }

    if (typeof krt === 'function') {
      krt('send', 'reservation_2more', createdReservationData)
    }
  } catch (error) {
    console.error('Error sending KARTE createdReservationData:', error)
  }
}

const karteReservationCancelled = async (reservation) => {
  try {
    const {
      store: { id: storeId },
      stylists,
      start_date,
      id: reservationId,
      code,
      status,
      user: { email },
      free_status,
      gender_preference,
    } = reservation

    const services = reservation.services || []
    const mainService = services.find((service) => service.exclusive_group === 'main')?.name || null
    const subServices = services
      .filter((service) => service.is_sub_treatment)
      .map((service) => service.name)

    const stylistName = stylists?.[0]?.name || null
    const displayName = getStylistDisplayName(free_status, gender_preference, stylistName)

    const cancelledReservationData = {
      store_id: String(storeId),
      main_service: mainService,
      sub_service: subServices,
      stylist_name: displayName,
      rsv_start_date: start_date,
      wait_for_cancel: status === 'waiting',
      reservation_id: String(reservationId),
      reservation_code: code,
      email,
    }

    if (typeof krt === 'function') {
      krt('send', 'reservation_2more_cancel', cancelledReservationData)
    }
  } catch (error) {
    console.error('Error in karteReservationCancelled:', error)
  }
}

export { karteLogin, karteReservationCompleted, karteReservationCancelled }
